/**
 *
 * @param str 文字列
 * @returns 正規表現でエスケープが必要であればエスケープする
 */
export const escapeRegExp = (str: string) => str.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
